import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var WithRightContent = styled.div.withConfig({
  displayName: "partials__WithRightContent",
  componentId: "sc-kyni7q-0"
})(["display:grid;grid-template-columns:8fr 4fr;gap:36px;", ""], maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n  "]))));